import React from 'react'
import Skeleton from 'react-loading-skeleton'

const SearchFormLandingPageLazyLoading = () => {
  return (
    <div>
        <Skeleton height={30} className="col-11 d-block mx-auto border" inline />
    </div>
  )
}

export default SearchFormLandingPageLazyLoading